/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { PetCompatibilityRequest } from './model/petCompatibilityRequest';
import type { PetCompatibilityResponse } from './model/petCompatibilityResponse';

/**
 * Saves an owner's answers to the sitter profile pet compatibility questions.

Works logged out and for owners with no pet, so it can't sit under a pet's URL.
 */
export const apiPetCompatibilityCreate = (
  petCompatibilityRequest: PetCompatibilityRequest,
  signal?: AbortSignal
) => {
  return HTTP<PetCompatibilityResponse>({
    url: `/api/v7/pet-compatibility/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: petCompatibilityRequest,
    signal,
  });
};

export const getApiPetCompatibilityCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetCompatibilityCreate>>,
    TError,
    { data: PetCompatibilityRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiPetCompatibilityCreate>>,
  TError,
  { data: PetCompatibilityRequest },
  TContext
> => {
  const mutationKey = ['apiPetCompatibilityCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetCompatibilityCreate>>,
    { data: PetCompatibilityRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiPetCompatibilityCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiPetCompatibilityCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetCompatibilityCreate>>
>;
export type ApiPetCompatibilityCreateMutationBody = PetCompatibilityRequest;
export type ApiPetCompatibilityCreateMutationError = ErrorType<unknown>;

export const useApiPetCompatibilityCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetCompatibilityCreate>>,
    TError,
    { data: PetCompatibilityRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiPetCompatibilityCreate>>,
  TError,
  { data: PetCompatibilityRequest },
  TContext
> => {
  const mutationOptions = getApiPetCompatibilityCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
